const colors = {
  transparent: 'transparent',
  white: '#ffffff',
  green: '#138636',
  red: '#c91432',
  yellow: '#ffbc11',

  blue: {
    100: '#5c5cb7',
    200: '#3d3daa',
    300: '#1f1f9c',
    400: '#00008f',
    500: '#00006d'
  },

  sienna: {
    100: '#e28972',
    200: '#dd7358',
    300: '#d75d3d',
    400: '#d24723',
    500: '#b03c1d'
  },

  grey: {
    100: '#fafafa',
    200: '#f0f0f0',
    300: '#e5e5e5',
    400: '#cccccc',
    500: '#999999',
    600: '#757575',
    700: '#5f5f5f',
    800: '#343c3d',
    900: '#111b1d'
  },

  ocean: {
    100: '#7698cb',
    200: '#4976ba',
    300: '#3a5e94',
    400: '#274168',
    500: '#17273e'
  },

  apache: {
    100: '#a79666',
    200: '#8a7333',
    300: '#6e5c28',
    400: '#4b3e1b',
    500: '#241d0c'
  },

  viridian: {
    100: '#738d87',
    200: '#5b7b73',
    300: '#48625c',
    400: '#32433f',
    500: '#181f1e'
  },

  teal: {
    100: '#41949f',
    200: '#027180',
    300: '#015a66',
    400: '#014750',
    500: '#002126'
  },

  tosca: {
    100: '#ac7074',
    200: '#914146',
    300: '#743438',
    400: '#6a2f33',
    500: '#321618'
  },

  new: {
    blue: {
      100: '#E2EFFF',
      500: '#0C0E45'
    }
  }
};

export default colors;
